<template>
  <el-header>
    <!-- Logo -->
    <div
      class="logo"
      :class="menuClass.logo_animation"
      @click="$router.push('/').catch(() => {})"
      style="cursor: pointer">
      <img src="/img/logo.png?v=1" />
      <span v-if="!menuIsCollapse">
        {{ authNm }}
      </span>
    </div>

    <!-- 기타 메세지 -->
    <template v-if="!$device.tablet">
      <el-button @click="menuCollapse" size="mini">
        <i class="icon iconfont icon-menu"></i>
      </el-button>
      <div class="title" :class="menuClass.title_animation">
        <div class="login_info">
          {{ $t('{showNm}, {accountNm}님 로그인 되었습니다.', { showNm: showNm || '오더엔', accountNm }) }}
        </div>
      </div>
    </template>

    <!-- 사용자 정보 표시 부분 -->
    <div class="info">
      <template v-if="!$device.tablet">
        <LanguageSelect />
        <UserInfoButton />
        <LogoutButton />
      </template>
      <template v-else>
        <el-button @click="toggleIsShowMobile" size="mini" circle>
          <i class="icon iconfont icon-menu"></i>
        </el-button>
      </template>
    </div>
  </el-header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserInfoButton from './UserInfoButton.vue'
import LogoutButton from './LogoutButton.vue'
import LanguageSelect from './LanguageSelect.vue'

export default {
  name: 'AppBar',

  components: {
    UserInfoButton,
    LogoutButton,
    LanguageSelect,
  },

  computed: {
    ...mapGetters({
      menuList: 'menu/menuList',
      menuIsCollapse: 'menu/menuIsCollapse',
      showNm: 'auth/showNm',
      authNm: 'auth/authNm',
      accountNm: 'auth/accountNm',
    }),
    menuClass() {
      if (this.menuIsCollapse) {
        return {}
      } else {
        return { logo_animation: 'logo_animation_expand', title_animation: 'title_expand' }
      }
    },
  },

  methods: {
    ...mapActions({
      toggleIsShowMobile: 'menu/toggleIsShowMobile',
    }),
    menuCollapse() {
      this.$store.commit('menu/setMenuIsCollapse', !this.menuIsCollapse)
    },
  },
}
</script>

<style scoped>
.el-header {
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 0 20px;
  border-bottom: none;
  background: var(--color-bg-card);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 10;
}
.el-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--color-primary), var(--color-primary-lighter));
}

.logo {
  display: flex;
  align-items: center;

  width: 230px;
  text-align: center;

  will-change: width;
  transition: width 0.5s ease-in;
  cursor: pointer;
}
.logo.logo_collapse {
  width: 100px;
}

.logo img {
  height: 50px;
}
.logo span {
  font-size: 18px;
  font-weight: 600;
  display: block;
  color: var(--color-text-primary);
}

.title {
  width: calc(100% - 360px);

  text-align: right;

  will-change: width;
  transition: width 0.5s ease-in;
}
.title.title_collapse {
  width: calc(100% - 270px);
}
.title .login_info {
  line-height: 32px;
  padding-right: 30px;
  font-size: 13px;
  color: var(--color-text-secondary);
}

.info {
  display: flex;
  align-items: center;
  gap: 10px;

  width: 160px;
  text-align: right;

  height: 60px;
  line-height: 60px;
}

@media (max-width: 1024px) {
  .el-header {
    justify-content: space-between;
  }
  .info {
    justify-content: flex-end;
  }
}
</style>
